var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "product-availability-editor",
    attrs: {
      "playground": true,
      "title": _vm.title
    },
    on: {
      "hidden": _vm.onHidden
    }
  }, [_c('product-availability-form', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "editable-provider": !_vm.isEditing,
      "errors": _vm.errors,
      "product": _vm.product,
      "values": _vm.productAvailability
    },
    on: {
      "cancel": _vm.hide,
      "submit": _vm.upsertProductAvailability
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf81abe8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductAvailabilityEditor.vue
// module id = 2113
// module chunks = 0